import {Fragment} from 'react'
import PropTypes from 'prop-types'
import {Map} from 'immutable'
import {useForm, FormProvider} from 'react-hook-form'
import {Link} from 'react-router'

import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import IconButton from '@mui/material/IconButton'

import {Button} from '../../../../dashboard/src/components/blocks/Buttons'
import {Text} from '../../../../dashboard/src/components/blocks/Texts'
import OtpInput from '../../../../shared_components/forms/v3/OtpInput'
import TfaSignInFrame from './TfaSignInFrame'


const CodeVerification = props => {
  const methods = useForm()

  return (
    <TfaSignInFrame
      className='code-verification'
      heading='Verify your identity'
      subtitle={
        <Fragment>
          {
            props.tfaEnrollment.get('mode') === 'phone' && (
              <Fragment>
                Enter the 6-digit code we sent to {props.obfuscatedPhoneNumber}.
              </Fragment>
            )
          }
          {
            props.tfaEnrollment.get('mode') === 'app' && (
              <Fragment>
                Enter the 6-digit code from your  <strong>authenticator app</strong>.
              </Fragment>
            )
          }
        </Fragment>
      }
      footer={
        <Fragment>
          <Button className='submit' onClick={methods.handleSubmit(props.verifyCode)} processing={props.loading}>Verify & continue</Button>
          {
            props.tfaEnrollment.get('mode') === 'phone' &&
              <Text className='helper-text'>Didn't receive a code? <IconButton className='resend' onClick={props.resendCode}>Resend</IconButton></Text>
          }
          <Link to='/auth/sign_in/tfa_alternatives' className='alternative-method' onClick={() => props.logMixpanelEvent('2fa_try_different_method')}>Try a different method</Link>
          <FormControlLabel
            control={<Checkbox checked={props.trustMe} onChange={props.toggleTrustMe} />}
            className='trust-device'
            label="Trust this device (we won't ask again for 30 days)"
          />
        </Fragment>
      }>
      <h5>Verification code</h5>
      <FormProvider {...methods}>
        <form className='otp-input-form' onSubmit={methods.handleSubmit(props.verifyCode)}>
          <OtpInput control={methods.control} error={props.error} />
          <input type='submit' hidden />
        </form>
      </FormProvider>
      {props.tfaEnrollment.get('mode') === 'app' && <Text className='helper-text'>Code refreshes every 30 seconds</Text>}
    </TfaSignInFrame>
  )
}

CodeVerification.propTypes = {
  error: PropTypes.string,
  tfaEnrollment: PropTypes.instanceOf(Map).isRequired,
  trustMe: PropTypes.bool.isRequired,
  toggleTrustMe: PropTypes.func.isRequired,
  obfuscatedPhoneNumber: PropTypes.string,
  verifyCode: PropTypes.func.isRequired,
  resendCode: PropTypes.func,
  logMixpanelEvent: PropTypes.func.isRequired
}

export default CodeVerification
